import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '../../shared/components/layout/layout.component';
import { InternalUserComponent } from './internal-user.component';
import { LayoutNoIdentityComponent } from 'src/app/shared/components/layout-no-identity/layout-no-identity.component';


@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      component: LayoutNoIdentityComponent,
      children: [
        {
          path: '',
          component: InternalUserComponent
        }
      ]
    }])],
  exports: [RouterModule]
})
export class InternalUserRoutingModule { }
